import { ReportingControllerBaseConfig } from '../../base';
import { DatabaseBlockController } from './databaseViewBlockInterface';
import { DatabaseBlockViewProps } from './databaseViewBlockProps';
import { createBlockItemController } from '../block';
import { CollectionController } from '../../page/common/collection';
export function createDatabaseBlockController(
    config: ReportingControllerBaseConfig & {
        collection: {
            controller: CollectionController;
        };
    }
): DatabaseBlockController {
    const blockController = createBlockItemController();
    const collectionController = config.collection.controller;

    return {
        useProps(context, item, props): DatabaseBlockViewProps {
            const block = blockController.useProps(context, item, props.item);

            // Get collection props from shared controller using pre-constructed props
            const collectionProps = collectionController.useProps(
                context,
                item.collectionAggregate,
                props.collection
            );

            return {
                block,
                collection: collectionProps,
            };
        },
    };
}
